// The line-icon set: 24-unit stroke glyphs, no fill, round caps (the Landscape map's .map-icon style). One per
// signal type for the newsfeed, one per gauge for the health dashboard, and a few for actions. Colour comes
// from currentColor, so the tint is the caller's class.

const GLYPHS: Record<string, JSX.Element> = {
  // signals
  'amount-mentioned': <><path d="M12 3v18" /><path d="M16.5 7.5c0-1.7-2-3-4.5-3s-4.5 1.3-4.5 3 2 3 4.5 3 4.5 1.3 4.5 3-2 3-4.5 3-4.5-1.3-4.5-3" /></>,
  'sow-sent': <><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v4h4" /><path d="M9 12h6M9 16h6" /></>,
  'proposal-sent': <><path d="M4 12l16-8-4 16-4-6z" /><path d="M12 14l8-10" /></>,
  intro: <><circle cx="8" cy="8" r="3" /><circle cx="17" cy="9" r="2.5" /><path d="M3 20c0-3 2.5-5 5-5s5 2 5 5" /><path d="M14 19c0-2.5 1.5-4 3.5-4s3.5 1.5 3.5 4" /></>,
  'next-step': <><path d="M4 12h13" /><path d="M13 6l6 6-6 6" /></>,
  decision: <><path d="M12 3l3 6 6 1-4.5 4.5 1 6.5-5.5-3-5.5 3 1-6.5L3 10l6-1z" /></>,
  invoice: <><path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" /><path d="M9 8h6M9 12h6" /></>,
  meeting: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></>,
  dormant: <><path d="M12 3a9 9 0 1 0 9 9c0-1-.2-2-.5-3A6 6 0 0 1 12 3z" /></>,
  'job-change': <><path d="M4 8h10" /><path d="M10 4l4 4-4 4" /><path d="M20 16H10" /><path d="M14 12l-4 4 4 4" /></>,
  signal: <><circle cx="12" cy="12" r="3" /><path d="M5.5 5.5a9 9 0 0 0 0 13M18.5 5.5a9 9 0 0 1 0 13" /></>,
  // gauges
  coverage: <><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c0-3.5 3-6 6.5-6s6.5 2.5 6.5 6" /><path d="M16 4.5a3.5 3.5 0 0 1 0 7" /><path d="M18 14.5c2 .8 3.5 2.8 3.5 5.5" /></>,
  reach: <><circle cx="5" cy="19" r="2" /><circle cx="19" cy="5" r="2" /><path d="M6.5 17.5l4-4M13.5 10.5l4-4" /><circle cx="12" cy="12" r="2" /></>,
  momentum: <><path d="M3 17l5-6 4 3 4-6 5 4" /><path d="M16 8h5v5" /></>,
  pipeline: <><path d="M3 5h18l-7 8v6l-4 2v-8z" /></>,
  risk: <><path d="M12 3l10 18H2z" /><path d="M12 10v4M12 17.5v.5" /></>,
  // actions
  photo: <><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7l1.5-3h5L16 7" /><circle cx="12" cy="13.5" r="3.5" /></>,
  upload: <><path d="M12 16V4" /><path d="M7 9l5-5 5 5" /><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3" /></>,
  fit: <><path d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5" /></>,
  person: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.5-7 8-7s8 3 8 7" /></>,
  pursuit: <><path d="M3 5h18l-7 8v6l-4 2v-8z" /></>,
  // channels: how a message was carried (REQ-105) — the preview control on a thread is drawn as its channel
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></>,
  // documents (REQ-119): a file by its kind, and the clip that attaches one to the conversation
  document: <><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v4h4" /><path d="M9 12h6M9 16h6" /></>,
  deck: <><rect x="3" y="4" width="18" height="12" rx="1.5" /><path d="M12 16v4M8 20h8" /><path d="M7 12l3-3 2 2 4-4" /></>,
  sheet: <><rect x="3" y="4" width="18" height="16" rx="1.5" /><path d="M3 9h18M3 14h18M9 4v16M15 4v16" /></>,
  paperclip: <><path d="M20 11.5l-8.5 8.5a5 5 0 0 1-7-7l9-9a3.3 3.3 0 0 1 4.7 4.7l-9 9a1.6 1.6 0 0 1-2.3-2.3l8.3-8.3" /></>,
  teams: <><rect x="3" y="7" width="12" height="10" rx="2" /><path d="M15 10l6-2v8l-6-2" /><circle cx="9" cy="4.5" r="1.5" /></>,
  chat: <><path d="M4 5h16v11H9l-5 4z" /></>,
  // connector health: the four states the Connect checklist can be in. Same stroke, no fill, no colour
  // of their own — the row's class tints them (--ok, --warn, --muted).
  check: <><path d="M4 12.5l5.5 5.5L20 6" /></>,
  warning: <><path d="M12 3l10 18H2z" /><path d="M12 10v4M12 17.5v.5" /></>,
  circle: <><circle cx="12" cy="12" r="8" /></>,
  dash: <><path d="M5 12h14" /></>,
}

export function LineIcon({ name, size = 16, className, title }: { name: string; size?: number; className?: string; title?: string }) {
  return (
    <svg className={`line-icon ${className ?? ''}`} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden={title ? undefined : true} role={title ? 'img' : undefined}>
      {title && <title>{title}</title>}
      {GLYPHS[name] ?? GLYPHS.signal}
    </svg>
  )
}

export const hasIcon = (name: string) => name in GLYPHS
